import React, { useEffect, useRef, useState } from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import RemoveCircleOutlinedIcon from "@mui/icons-material/RemoveCircleOutlined";
import baseURL from "../../../configs/api";
import axois from "../../../configs/axois";
import ImagePopup from "./ImagePopup";
import CustomFormatDatePicker from "../../../components/common/CustomFormatDatePicker";
import { useTheme } from "../../../components/hooks/useTheme";
import useGeneral from "../../../components/hooks/useGeneral";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";


type ExtraInformation = {
  id: number;
  idNumber: string;
  issueDate: string;
  exprationDate: string;
  filePath: string;
  idTypeId: string;
  customerId: number;
  type: string;
  imageSize: number,
  uploadedAt: string,
  uploadedBy: string
};

type Props = {
  itemIndex: number;
  handleDeleteExtraRow: (id: number) => void;
  row: ExtraInformation;
  changeOnExtraValue: (row: ExtraInformation) => void;
  birthDay: string;
  disabeld?: boolean;
};

export default function AddIdentification({
  itemIndex,
  handleDeleteExtraRow,
  row,
  changeOnExtraValue,
  birthDay,
  disabeld
}: Props) {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { handleTenantError }: any = useTenant();
  const { themeStyles } = useTheme();
  const { dateFormat }: any = useGeneral();
  const [type, setType] = useState([]);
  const [file, setFile] = useState<FileList | null>(null);
  const [popup, setPopup] = useState<boolean>(false);
  const [fileName, setFileName] = useState<string>(row.filePath);
  const [isUpload, setUpload] = useState<boolean>(row.filePath ? true : false);
  const [idNumber, setIdNumber] = useState(row.idNumber);
  const [typeValue, setTypeValue] = useState(row.idTypeId);
  const [issuedDateValue, setIssuedDateValue] = useState(row.issueDate);
  const [expDateValue, setExpDateValue] = useState(row.exprationDate);
  const [fileSize, setFileSize] = useState<number>(row.imageSize);

  useEffect(() => {
    axois
      .get(`${baseURL}IdType`, {
        headers: {
          'X-Tenant-ID': tenantId,
           "Content-Type": "application/json" 
        }
      })
      .then((response) => {
        setType(
          response?.data?.map((item: any) => {
            return { value: item.id, label: item.name };
          })
        );
        setTypeValue(row?.idTypeId ? row?.idTypeId : response?.data[0]?.id);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let data: ExtraInformation = {
      id: row.id,
      idNumber: idNumber,
      issueDate: issuedDateValue,
      exprationDate: expDateValue,
      filePath: fileName,
      idTypeId: typeValue,
      customerId: row.customerId,
      type: row.type,
      imageSize: fileSize,
      uploadedAt: row.uploadedAt,
      uploadedBy: row.uploadedBy
    };
    changeOnExtraValue(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNumber, typeValue, issuedDateValue, expDateValue, isUpload, fileSize, fileName]);

  const inputFileRef = useRef<HTMLInputElement>(null);
  const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    /*Selected files data can be collected here.*/
    const selectedFiles = e.target.files as FileList;
    if (selectedFiles.length !== 0) {
      setFile(selectedFiles);
      setFileSize(selectedFiles[0].size);
      setPopup(true);
    }

  };

  return (
    <>
      <tr className={`border-b ${themeStyles.main.borderColor}`}>
        <td className="py-2 pr-[0.25rem]">
          <select
            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
            value={typeValue}
            disabled={disabeld}
            onChange={(e) => setTypeValue(e.target.value)}
          >
            {
              type?.map((item: any) => (
                <option className={`${themeStyles.main.tailwindSectionBg}`} key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))
            }
          </select>
        </td>

        <td className="py-2 px-[0.25rem]">
          <input
            type="text"
            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
            value={idNumber}
            disabled={disabeld}
            onChange={(e) => setIdNumber(e.target.value)}
            required
          />
        </td>

        <td className="text-right py-2 px-[0.25rem]">
          <CustomFormatDatePicker
            value={issuedDateValue}
            disabled={disabeld}
            onChange={(value) => {
              setIssuedDateValue(value);
            }}
            showValidMessage={false}
            dateFormat={dateFormat}
            required={true}
          />
        </td>

        <td className="text-right py-2 px-[0.25rem]">
          <CustomFormatDatePicker
            value={expDateValue}
            disabled={disabeld}
            onChange={(value) => {
              setExpDateValue(value);
            }}
            showValidMessage={false}
            dateFormat={dateFormat}
            required={true}
          />
        </td>

        <td className="w-[30%] py-2 pl-[0.25rem]">
          <div className="flex justify-between items-center gap-2">
            {isUpload ? (
              <p
                className={`m-0 cursor-pointer whitespace-nowrap text-ellipsis overflow-hidden w-[100px] text-sm flex items-center gap-1 ${themeStyles.form.tailwindInputTextColor}`}
                onClick={() => setPopup(true)}
              >
                <AttachFileIcon style={{ fontSize: "12px", color: "black" }} />
                {fileName}
              </p>
            ) : (
              <>
                <input
                  type="file"
                  ref={inputFileRef}
                  disabled={disabeld}
                  onChangeCapture={onFileChangeCapture}
                  className="hidden"
                />
                {
                  !disabeld && (
                    <p
                      className={`m-0 cursor-pointer text-sm flex items-center gap-1 ${themeStyles.form.tailwindInputTextColor}`}
                      onClick={() => {
                        if (inputFileRef.current) {
                          inputFileRef.current.value = "";
                        }
                        inputFileRef.current?.click()
                      }}
                    >
                      <CloudUploadIcon style={{ fontSize: "12px", color: themeStyles.form.inputTextColor }} />
                      Upload
                    </p>
                  )
                }

              </>
            )}

            {
              !disabeld && (
                <div className="flex flex-row gap-1">
                  <RemoveCircleOutlinedIcon
                    sx={{
                      fontSize: "12px",
                      color: themeStyles.form.inputTextColor,
                      cursor: "pointer",
                      "&:hover": {
                        color: "red",
                      },
                    }}
                    onClick={() => handleDeleteExtraRow(itemIndex)}
                  />
                </div>
              )
            }

          </div>
        </td>
      </tr>

      {
        popup && (
          <ImagePopup
            handlePopup={() => setPopup(false)}
            showPopup={popup}
            setPopup={setPopup}
            fileName={file}
            setFile={setFile}
            fileSize={fileSize}
            setFileSize={setFileSize}
            uploadedAt={row?.uploadedAt}
            uploadedBy={row?.uploadedBy}
            setFileName={(name: string) => {
              setFileName(name);
              setUpload(true);
            }}
            filePath={fileName}
            saved={isUpload}
            item={row}
          />
        )
      }
    </>
  );
}
